import { RUN_COLUMNS } from "@/components/agents/agent-runs";
import { DataTable } from "@/components/ui/data-table";
import { createFileRoute, useLoaderData } from "@tanstack/react-router";

/** `/agents/$slug/activity` — every run: trigger, duration, real token
 *  burn, estimated cost and what it produced. */
export const Route = createFileRoute("/_app/agents/$slug/activity")({
  component: AgentActivity,
});

function AgentActivity() {
  const data = useLoaderData({ from: "/_app/agents/$slug" });
  return (
    <DataTable
      columns={RUN_COLUMNS}
      rows={data.runs}
      rowKey={(r) => r.id}
      rowTestId={() => "agent-run-row"}
      density="compact"
      emptyState={
        <span data-testid="runs-empty">No runs yet — the agent hasn't done anything.</span>
      }
    />
  );
}
